import React, { useState } from 'react';
import Header from './components/Header';
import Home from './components/Home';
import RestaurantSection from './components/RestaurantSection';
import MovieSection from './components/MovieSection';
import LanguageSection from './components/LanguageSection';
import CoinAnalysisSection from './components/CoinAnalysisSection';
import PDFSection from './components/PDFSection';
import NasdaqSection from './components/NasdaqSection';
import ITNewsSection from './components/ITNewsSection';
import BookSection from './components/BookSection';
import PlaceSection from './components/PlaceSection';
import CommunitySection from './components/CommunitySection';
import OpenCoreSection from './components/OpenCoreSection';
import SpaceBackground from './components/SpaceBackground';
import GalaxyBand from './components/GalaxyBand';
import Footer from './components/Footer';

function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [activeSection, setActiveSection] = useState('it-news-section');

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <Home />;
      case 'community':
        return <CommunitySection />;
      case 'open-core':
        return <OpenCoreSection />;
      case 'free-service':
        switch (activeSection) {
          case 'restaurant-section':   return <RestaurantSection />;
          case 'movie-section':        return <MovieSection />;
          case 'language-section':     return <LanguageSection />;
          case 'coin-analysis-section': return <CoinAnalysisSection />;
          case 'pdf-section':           return <PDFSection />;
          case 'nasdaq-analysis-section': return <NasdaqSection />;
          case 'it-news-section':      return <ITNewsSection />;
          case 'book-section':         return <BookSection />;
          case 'place-section':        return <PlaceSection />;
          default:                     return <ITNewsSection />;
        }
      default:
        return <Home />;
    }
  };

  return (
    <div className="App">
      <SpaceBackground />
      <Header
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <main>
        {renderContent()}
        {/* renderContent 바깥에 두어 탭이 바뀌어도 언마운트되지 않는다 (음악 유지) */}
        <GalaxyBand visible={activeTab === 'home'} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
